import { AwsRumConfig } from 'aws-rum-web';
import { useEffect } from 'react';

export interface AWSRumProps {
  rumGuestRoleArn: string;
  applicationIds: Record<string, string>;
  identityPoolId: string;
}
const VERSION = '1.0.0';
const REGION = 'us-east-1';
const ENDPOINT = 'https://dataplane.rum.us-east-1.amazonaws.com';
let initialized = false;

export const intilializeAWSRum = (config: AwsRumConfig, applicationId: string) => {
  if (initialized) return;
  initialized = true;
  // Since the library is only used client side and is big (>100kb) we download it asynchronously
  import('aws-rum-web').then(({ AwsRum }) => {
    const awsRum = new AwsRum(applicationId, VERSION, REGION, config);
    window.onerror = (message) => {
      awsRum.recordError(message);
    };
  });
};

export const useAWSRum = ({ rumGuestRoleArn, applicationIds, identityPoolId }: AWSRumProps) => {
  useEffect(() => {
    if (!rumGuestRoleArn || !applicationIds || !identityPoolId) {
      return;
    }

    const tld = window.location.hostname.split('.').pop();
    const applicationId = tld ? applicationIds[`.${tld}`] : undefined;

    if (!applicationId) {
      return;
    }

    try {
      intilializeAWSRum(
        {
          sessionSampleRate: 1,
          guestRoleArn: rumGuestRoleArn,
          identityPoolId,
          endpoint: ENDPOINT,
          telemetries: ['performance', 'errors', 'http'],
          allowCookies: false,
          enableXRay: false,
        },
        applicationId,
      );
    } catch (error) {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }, [applicationIds, identityPoolId, rumGuestRoleArn]);
};

export function getAwsRumConfig() {
  // Accessing aws rum environment variables
  const rumGuestRoleArn = process.env.RUM_GUEST_ROLE_ARN as string;
  const identityPoolId = process.env.IDENTITY_POOL_ID as string;
  let applicationIds: Record<string, string> = {};
  if (process.env.APPLICATION_IDS) {
    try {
      applicationIds = JSON.parse(process.env.APPLICATION_IDS) as Record<string, string>;
    } catch (err) {
      throw new Error(`Invalid JSON in APPLICATION_IDS: ${(err as Error).message}`);
    }
  }
  return {
    rumGuestRoleArn,
    identityPoolId,
    applicationIds,
  };
}
